import styled from 'styled-components';
import { token } from '@bynder/design-system';
import aiSVG from '../../../assets/icons/ai.svg?raw';
import archiveSVG from '../../../assets/icons/archive.svg?raw';
import cssSVG from '../../../assets/icons/css.svg?raw';
import docSVG from '../../../assets/icons/doc.svg?raw';
import fontSVG from '../../../assets/icons/font.svg?raw';
import htmlSVG from '../../../assets/icons/html.svg?raw';
import lrSVG from '../../../assets/icons/lr.svg?raw';
import pdfSVG from '../../../assets/icons/pdf.svg?raw';
import photoSVG from '../../../assets/icons/photo.svg?raw';
import pptSVG from '../../../assets/icons/ppt.svg?raw';
import programSVG from '../../../assets/icons/program.svg?raw';
import psdSVG from '../../../assets/icons/psd.svg?raw';
import sketchSVG from '../../../assets/icons/sketch.svg?raw';
import svgSVG from '../../../assets/icons/svg.svg?raw';
import unknownSVG from '../../../assets/icons/unknown.svg?raw';
import xlsSVG from '../../../assets/icons/xls.svg?raw';
import { TEXT } from '../../../constants/styles';
import { TypographyHeading } from '../../../types/typography';
import { getTypography } from './constants';
import { svgtob64 } from '../../../helpers/utils';

export const StyledPlaceholderContainer = styled.div`
  height: 80px;
  width: 80%;
  max-width: 80px;
  background-color: ${token.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

  border: 1px ${token.gray75a} solid;
  border-radius: ${token.radiusMedium};

  > img {
    padding-top: 10px;
    border-radius: inherit;

    &[alt='zip'],
    &[alt='rar'] {
      padding-top: 0;
    }
  }

  > h6 {
    height: 20px;
    width: 80px;

    ${props => getTypography(TypographyHeading.H6, props.theme, false)};
    font-size: ${TEXT.FONT_SIZE_CAPTION};
    margin: 0;
    text-align: center;
    line-height: 20px;

    color: ${token.gray300a};
  }
`;

export const placeholderFiles = {
  jpg: svgtob64(photoSVG),
  png: svgtob64(photoSVG),
  gif: svgtob64(photoSVG),
  bmp: svgtob64(photoSVG),
  tiff: svgtob64(photoSVG),
  tif: svgtob64(photoSVG),
  ai: svgtob64(aiSVG),
  eps: svgtob64(aiSVG),
  psd: svgtob64(psdSVG),
  dng: svgtob64(lrSVG),
  doc: svgtob64(docSVG),
  docx: svgtob64(docSVG),
  xls: svgtob64(xlsSVG),
  xlsx: svgtob64(xlsSVG),
  ppt: svgtob64(pptSVG),
  pptx: svgtob64(pptSVG),
  pdf: svgtob64(pdfSVG),
  raw: svgtob64(photoSVG),
  svg: svgtob64(svgSVG),
  sketch: svgtob64(sketchSVG),
  jpeg: svgtob64(photoSVG),
  webp: svgtob64(photoSVG),
  pages: svgtob64(docSVG),
  numbers: svgtob64(xlsSVG),
  zip: svgtob64(archiveSVG),
  rar: svgtob64(archiveSVG),
  css: svgtob64(cssSVG),
  scss: svgtob64(cssSVG),
  html: svgtob64(htmlSVG),
  exe: svgtob64(programSVG),
  app: svgtob64(programSVG),
  ttf: svgtob64(fontSVG),
  otf: svgtob64(fontSVG),
  woff: svgtob64(fontSVG),
  eot: svgtob64(fontSVG),
  unknown: svgtob64(unknownSVG),
};

export type AssetExtension = keyof typeof placeholderFiles;
